import React, { forwardRef } from "react";
import PropTypes from "prop-types";

import styles from "./Grid.scss";

// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization
const Col = forwardRef(
  ({ children, s, m, l, xl, marginBottom, customClass, ...others }, ref) => {
    let classes = "";
    classes += s ? `${styles[`col_s-${s}`]} ` : "";
    classes += m ? `${styles[`col_m-${m}`]} ` : "";
    classes += l ? `${styles[`col_l-${l}`]} ` : "";
    classes += xl ? `${styles[`col_xl-${xl}`]} ` : "";
    classes += marginBottom ? `${styles["col--margin-bottom"]} ` : "";
    classes += customClass || "";
    return (
      <div className={classes} ref={ref} {...others}>
        {children}
      </div>
    );
  }
);

Col.propTypes = {
  s: PropTypes.number,
  m: PropTypes.number,
  l: PropTypes.number,
  xl: PropTypes.number,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  marginBottom: PropTypes.bool,
  customClass: PropTypes.string,
};

Col.defaultProps = {
  s: undefined,
  m: undefined,
  l: undefined,
  xl: undefined,
  children: undefined,
  marginBottom: false,
  customClass: undefined,
};

Col.displayName = "Grid.Col";

export default Col;
